import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=64c3f548&scoped=true&"
import script from "./Learning.vue?vue&type=script&lang=js&"
export * from "./Learning.vue?vue&type=script&lang=js&"
import style0 from "./Learning.vue?vue&type=style&index=0&id=64c3f548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3f548",
  null
  
)

export default component.exports